module.exports = __webpack_public_path__ + "static/media/more_enabled.d2adc62f.svg";